import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './auth/index.js';
import { configureAuth } from './auth/index.js';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import { ToastContainer } from './components/ToastContainer.jsx';
import { Layout } from './components/Layout.jsx';
import { Landing } from './pages/Landing.jsx';
import { Login } from './pages/Login.jsx';
import { Dashboard } from './pages/Dashboard.jsx';
import { Board } from './pages/Board.jsx';
import { Settings } from './pages/Settings.jsx';
import { SalaryComparison } from './pages/SalaryComparison.jsx';
import { QuickClip } from './pages/QuickClip.jsx';
import { Import } from './pages/Import.jsx';
import { Help } from './pages/Help.jsx';
import { Practice } from './pages/Practice.jsx';
import { SharedView } from './pages/SharedView.jsx';
import { Privacy } from './pages/Privacy.jsx';
import { Admin } from './pages/Admin.jsx';

configureAuth();

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/board" element={<Board />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/salary" element={<SalaryComparison />} />
              <Route path="/import" element={<Import />} />
              <Route path="/help" element={<Help />} />
              <Route path="/practice" element={<Practice />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route
              path="/quick-clip"
              element={
                <ProtectedRoute>
                  <QuickClip />
                </ProtectedRoute>
              }
            />
            <Route path="/shared/:token" element={<SharedView />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <ToastContainer />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
